function onAccordionClick(event) {
    const target = event.currentTarget;

    target.classList.toggle('active');
    const panel = target.nextElementSibling;
    if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
    } else {
        panel.style.maxHeight = `${panel.scrollHeight * 2}px`;
    }
}

export function initAccordion(query) {
    document.querySelectorAll(query).forEach(element => {
        element.removeEventListener('click', onAccordionClick);
        element.addEventListener('click', onAccordionClick);
    });
}

export function initInlineAccordion(query, buttonQuery, contentQuery) {
    document.querySelectorAll(query).forEach(element => {
        function onInlineAccordionClick(event) {
            const target = event.currentTarget;

            target.classList.toggle('active');
            const panel = element.querySelector(contentQuery);
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = `${panel.scrollHeight * 2}px`;
            }
        }
        const button = element.querySelector(buttonQuery);
        // With this solution, removeEventListener will not work since it's a new function at each iteration
        // Can we find an other way to remove old listener ?
        button.removeEventListener('click', onInlineAccordionClick);
        button.addEventListener('click', onInlineAccordionClick);
    });
}

export function init() {
    initAccordion('.accordion');
}

export default {
    init,
    initAccordion,
};
